// extracted by mini-css-extract-plugin
export default {"field":"TextFileAddModal_field__4GMjI"};